const API_BASE_URL =
    process.env.REACT_APP_GENESIS_API_URL ||
    "https://genesis-api-prod-bzfxa2a0aybugqhp.westus2-01.azurewebsites.net";

function compactFilter(values) {
    return Object.fromEntries(
        Object.entries(values).filter(([, value]) => {
            if (value == null) {
                return false;
            }
            if (typeof value === "string") {
                return value.trim().length > 0;
            }
            if (typeof value === "number") {
                return value !== 0;
            }
            return true;
        })
    );
}

export function buildSearchFilter({ state, serviceType, city, query }) {
    const filter = {
        country: "US",
    };

    if (state?.trim()) {
        filter.state = state.trim();
    }

    if (serviceType && serviceType !== "all") {
        filter.serviceType = serviceType;
    }

    if (city?.trim()) {
        filter.city = city.trim();
    }

    if (query?.trim()) {
        filter.filterName = query.trim();
    }

    return compactFilter(filter);
}

export async function fetchMetadata({ signal } = {}) {
    const response = await fetch(`${API_BASE_URL}/api/Metadata/get_all`, {
        headers: {
            Accept: "application/json",
        },
        signal,
    });

    if (!response.ok) {
        throw new Error("Unable to load directory filters right now.");
    }

    const payload = await response.json();

    if (payload.status_code !== 200) {
        throw new Error(payload.message || "Unable to load directory filters right now.");
    }

    return (
        payload.data ?? {
            rehabServiceTypes: [],
            rehabStates: [],
            rehabCities: [],
        }
    );
}

export async function searchRehabCenters({
    pageNumber = 1,
    pageSize = 6,
    filter = {},
    signal,
}) {
    const safePageNumber = Math.max(1, Number(pageNumber) || 1);
    const safePageSize = Math.max(1, Number(pageSize) || 6);

    const response = await fetch(`${API_BASE_URL}/api/Rehab/search_rehab_centers`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            pageNumber: safePageNumber,
            pageSize: safePageSize,
            filter,
        }),
        signal,
    });

    if (!response.ok) {
        throw new Error("Unable to load treatment directory right now.");
    }

    const payload = await response.json();

    if (payload.status_code !== 200) {
        throw new Error(payload.message || "Unable to load treatment directory right now.");
    }

    return payload.data ?? { items: [], hasMore: false, totalPages: 0, totalRecords: 0 };
}
